import { render, staticRenderFns } from "./ProfilePanel.vue?vue&type=template&id=3051b626&scoped=true&"
import script from "./ProfilePanel.vue?vue&type=script&lang=js&"
export * from "./ProfilePanel.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePanel.vue?vue&type=style&index=0&id=3051b626&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3051b626",
  null
  
)

export default component.exports